import { useState } from 'react';
import axios from 'axios';
import { API_URL } from './utils';
import { INSTRUMENTS } from '../ingestion_tab/constants';
import FkCombobox from '../FkCombobox';

export const SingleIngestionTab = ({ authHeaders }) => {
  const [ingestionType, setIngestionType] = useState('person');
  const [ingestionSuccess, setIngestionSuccess] = useState(null);
  const [ingestionError, setIngestionError] = useState(null);
  const [ingestionLoading, setIngestionLoading] = useState(false);
  const [personName, setPersonName] = useState('');
  const [personBio, setPersonBio] = useState('');
  const [personInstruments, setPersonInstruments] = useState([]);
  const [personDob, setPersonDob] = useState('');
  const [personDod, setPersonDod] = useState('');
  const [personDescBrief, setPersonDescBrief] = useState('');
  const [songTitle, setSongTitle] = useState('');
  const [songComposer, setSongComposer] = useState('');
  const [eventStep, setEventStep] = useState(1);
  const [eventTitle, setEventTitle] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [eventDescription, setEventDescription] = useState('');
  const [eventLocationPick, setEventLocationPick] = useState(null);
  const [eventPerformers, setEventPerformers] = useState([]);
  const [eventSetlist, setEventSetlist] = useState([]);
  const [newPerformerPick, setNewPerformerPick] = useState(null);
  const [newPerformerRolePick, setNewPerformerRolePick] = useState(null);
  const [newSongPick, setNewSongPick] = useState(null);
  const [newSongComposer, setNewSongComposer] = useState('');
  const [newSongTrack, setNewSongTrack] = useState('');
  const [albumTitle, setAlbumTitle] = useState('');
  const [albumCatalogueNum, setAlbumCatalogueNum] = useState('');
  const [albumUpc, setAlbumUpc] = useState('');
  const [albumTitleArtist, setAlbumTitleArtist] = useState('');
  const [albumReleaseDate, setAlbumReleaseDate] = useState('');
  const [albumExecutiveProducer, setAlbumExecutiveProducer] = useState('');
  const [albumProducer, setAlbumProducer] = useState('');
  const [albumAssociateProducer, setAlbumAssociateProducer] = useState('');
  const [albumRecordingEngineer, setAlbumRecordingEngineer] = useState('');
  const [albumEditingEngineer, setAlbumEditingEngineer] = useState('');
  const [albumMixingEngineer, setAlbumMixingEngineer] = useState('');
  const [albumMasteringEngineer, setAlbumMasteringEngineer] = useState('');
  const [albumAssistants, setAlbumAssistants] = useState('');
  const [albumRecordingDates, setAlbumRecordingDates] = useState('');
  const [albumRecordingLocation, setAlbumRecordingLocation] = useState('');
  const [albumCoverArt, setAlbumCoverArt] = useState('');
  const [albumCoverArtDesign, setAlbumCoverArtDesign] = useState('');
  const [albumPackageDesign, setAlbumPackageDesign] = useState('');
  const [albumPhotography, setAlbumPhotography] = useState('');
  const [albumLinerNotesAuthor, setAlbumLinerNotesAuthor] = useState('');
  const [albumLinerNotesText, setAlbumLinerNotesText] = useState('');
  const [albumSponsorCredit, setAlbumSponsorCredit] = useState('');
  const [albumAwards, setAlbumAwards] = useState('');
  const [albumLinkToProduct, setAlbumLinkToProduct] = useState('');
  const [trackAlbumPick, setTrackAlbumPick] = useState(null);
  const [trackSongPick, setTrackSongPick] = useState(null);
  const [trackNewSongComposer, setTrackNewSongComposer] = useState('');
  const [trackNumber, setTrackNumber] = useState('');
  const [trackIsrc, setTrackIsrc] = useState('');
  const [trackDuration, setTrackDuration] = useState('');
  const [trackVocalInstrumental, setTrackVocalInstrumental] = useState('');
  const [trackMusicians, setTrackMusicians] = useState('');

  const resetIngestionForms = () => {
    setPersonName(''); setPersonBio(''); setPersonInstruments([]);
    setPersonDob(''); setPersonDod(''); setPersonDescBrief('');
    setSongTitle(''); setSongComposer('');
    setEventStep(1); setEventTitle(''); setEventDate('');
    setEventDescription(''); setEventLocationPick(null);
    setEventPerformers([]); setEventSetlist([]);
    setNewPerformerPick(null); setNewPerformerRolePick(null);
    setNewSongPick(null); setNewSongComposer(''); setNewSongTrack('');
    setAlbumTitle(''); setAlbumCatalogueNum(''); setAlbumUpc('');
    setAlbumTitleArtist(''); setAlbumReleaseDate('');
    setAlbumExecutiveProducer(''); setAlbumProducer(''); setAlbumAssociateProducer('');
    setAlbumRecordingEngineer(''); setAlbumEditingEngineer('');
    setAlbumMixingEngineer(''); setAlbumMasteringEngineer(''); setAlbumAssistants('');
    setAlbumRecordingDates(''); setAlbumRecordingLocation('');
    setAlbumCoverArt('');
    setAlbumCoverArtDesign(''); setAlbumPackageDesign(''); setAlbumPhotography('');
    setAlbumLinerNotesAuthor(''); setAlbumLinerNotesText(''); setAlbumSponsorCredit('');
    setTrackAlbumPick(null); setTrackSongPick(null); setTrackNewSongComposer(''); setTrackNumber(''); setTrackIsrc('');
    setTrackDuration(''); setTrackVocalInstrumental(''); setTrackMusicians('');
  };

  const switchIngestionType = (type) => {
    setIngestionType(type);
    setIngestionSuccess(null);
    setIngestionError(null);
  };

  const toggleInstrument = (inst) => {
    setPersonInstruments((prev) =>
      prev.includes(inst) ? prev.filter((i) => i !== inst) : [...prev, inst],
    );
  };

  const addPerformer = () => {
    if (!newPerformerPick) return;
    setEventPerformers((prev) => [
      ...prev,
      { personPick: newPerformerPick, rolePick: newPerformerRolePick },
    ]);
    setNewPerformerPick(null);
    setNewPerformerRolePick(null);
  };

  const removePerformer = (idx) => {
    setEventPerformers((prev) => prev.filter((_, i) => i !== idx));
  };

  const addSetlistSong = () => {
    if (!newSongPick) return;
    setEventSetlist((prev) => [
      ...prev,
      {
        songPick: newSongPick,
        composer: newSongPick.createWith ? newSongComposer.trim() : '',
        trackNumber: newSongTrack || prev.length + 1,
      },
    ]);
    setNewSongPick(null);
    setNewSongComposer('');
    setNewSongTrack('');
  };

  const removeSetlistSong = (idx) => {
    setEventSetlist((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleIngestionSubmit = async () => {
    setIngestionError(null);
    setIngestionSuccess(null);

    let url = '';
    let payload = null;
    let successLabel = '';

    if (ingestionType === 'person') {
      if (!personName.trim()) { setIngestionError('Person name is required.'); return; }
      url = `${API_URL}/api/admin/archive/people`;
      payload = {
        name: personName.trim(),
        bio: personBio.trim() || undefined,
        instruments: personInstruments,
        dob: personDob || undefined,
        dod: personDod || undefined,
        desc_brief: personDescBrief.trim() || undefined,
      };
      successLabel = `Person "${personName.trim()}" submitted successfully.`;
    } else if (ingestionType === 'song') {
      if (!songTitle.trim()) { setIngestionError('Song title is required.'); return; }
      url = `${API_URL}/api/admin/archive/songs`;
      payload = {
        title: songTitle.trim(),
        composer: songComposer.trim() || undefined,
      };
      successLabel = `Song "${songTitle.trim()}" submitted successfully.`;
    } else if (ingestionType === 'event') {
      if (!eventTitle.trim() || !eventDate) { setIngestionError('Event title and date are required.'); return; }
      url = `${API_URL}/api/admin/archive/events`;
      payload = {
        title: eventTitle.trim(),
        date: eventDate,
        description: eventDescription.trim() || undefined,
        location: eventLocationPick?.createWith || undefined,
        location_id: eventLocationPick?.id || undefined,
        performers: eventPerformers.map((p) => ({
          person_id: p.personPick?.id,
          name: p.personPick?.createWith,
          role_id: p.rolePick?.id,
          role: p.rolePick?.createWith,
        })),
        setlist: eventSetlist.map((s) => ({
          song_id: s.songPick?.id,
          title: s.songPick?.createWith,
          composer: s.composer || undefined,
          track_number: s.trackNumber,
        })),
      };
      successLabel = `Concert / Event "${eventTitle.trim()}" submitted successfully.`;
    } else if (ingestionType === 'album') {
      if (!albumTitle.trim()) { setIngestionError('Album title is required.'); return; }
      url = `${API_URL}/api/admin/archive/albums`;
      payload = {
        title: albumTitle.trim(),
        catalogue_num: albumCatalogueNum.trim() || undefined,
        upc: albumUpc.trim() || undefined,
        title_artist: albumTitleArtist.trim() || undefined,
        release_date: albumReleaseDate.trim() || undefined,
        executive_producer: albumExecutiveProducer.trim() || undefined,
        producer: albumProducer.trim() || undefined,
        associate_producer: albumAssociateProducer.trim() || undefined,
        recording_engineer: albumRecordingEngineer.trim() || undefined,
        editing_engineer: albumEditingEngineer.trim() || undefined,
        mixing_engineer: albumMixingEngineer.trim() || undefined,
        mastering_engineer: albumMasteringEngineer.trim() || undefined,
        assistants: albumAssistants.trim() || undefined,
        recording_dates: albumRecordingDates.trim() || undefined,
        recording_location: albumRecordingLocation.trim() || undefined,
        cover_art: albumCoverArt.trim() || undefined,
        cover_art_design: albumCoverArtDesign.trim() || undefined,
        package_design: albumPackageDesign.trim() || undefined,
        photography: albumPhotography.trim() || undefined,
        liner_notes_author: albumLinerNotesAuthor.trim() || undefined,
        liner_notes_text: albumLinerNotesText.trim() || undefined,
        sponsor_credit: albumSponsorCredit.trim() || undefined,
        awards: albumAwards.trim() || undefined,
        link_to_product: albumLinkToProduct.trim() || undefined,
      };
      successLabel = `Album "${albumTitle.trim()}" submitted successfully.`;
    } else if (ingestionType === 'album_track') {
      if (!trackAlbumPick || !trackAlbumPick.id) {
        setIngestionError('Pick an album from the dropdown.');
        return;
      }
      if (!trackSongPick) {
        setIngestionError('Pick or create a song.');
        return;
      }
      url = `${API_URL}/api/admin/archive/album-tracks`;
      payload = {
        album_id: trackAlbumPick.id,
        ...(trackSongPick.id
          ? { song_id: trackSongPick.id }
          : {
              song: trackSongPick.createWith,
              song_composer: trackNewSongComposer.trim() || undefined,
            }),
        track_number: trackNumber || undefined,
        isrc: trackIsrc.trim() || undefined,
        duration: trackDuration.trim() || undefined,
        vocal_instrumental: trackVocalInstrumental || undefined,
        musicians: trackMusicians.trim() || undefined,
      };
      successLabel = `Album track for "${trackAlbumPick.label}" submitted successfully.`;
    } else {
      return;
    }

    setIngestionLoading(true);
    try {
      await axios.post(url, payload, { headers: authHeaders() });
      setIngestionSuccess(successLabel);
      resetIngestionForms();
    } catch (err) {
      setIngestionError(err.response?.data?.error || err.message || 'Submission failed');
    } finally {
      setIngestionLoading(false);
    }
  };

  return (
    <>
      {ingestionError && (
        <div className="AdminPortal-banner AdminPortal-banner--error" role="alert">
          {ingestionError}
        </div>
      )}
      {ingestionSuccess && (
        <div className="AdminPortal-banner AdminPortal-banner--success" role="status">
          {ingestionSuccess}
        </div>
      )}

      <div className="AdminPortal-ingestionTypes">
        {['person', 'song', 'event', 'album', 'album_track'].map((type) => (
          <button
            key={type}
            type="button"
            className={`AdminPortal-ingestionType ${ingestionType === type ? 'AdminPortal-ingestionType--active' : ''}`}
            onClick={() => switchIngestionType(type)}
          >
            {type === 'event'
              ? 'Concert / Event'
              : type === 'album'
                ? 'Albums'
                : type === 'album_track'
                  ? 'Album Tracks'
                  : type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      {ingestionType === 'person' && (
        <section className="AdminPortal-section">
          <h2 className="AdminPortal-sectionTitle">Add a person</h2>
          <p className="AdminPortal-sectionLead">
            Add a new artist, musician, or contributor to the archive.
          </p>
          <div className="AdminPortal-form">
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Name *</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={personName}
                onChange={(e) => setPersonName(e.target.value)}
                placeholder="e.g. Miles Davis"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Short description</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={personDescBrief}
                onChange={(e) => setPersonDescBrief(e.target.value)}
                placeholder="e.g. Pittsburgh jazz pianist and educator"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Date of birth</span>
              <input
                type="date"
                className="AdminPortal-input"
                value={personDob}
                onChange={(e) => setPersonDob(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Date of death</span>
              <input
                type="date"
                className="AdminPortal-input"
                value={personDod}
                onChange={(e) => setPersonDod(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Bio</span>
              <textarea
                className="AdminPortal-textarea"
                value={personBio}
                onChange={(e) => setPersonBio(e.target.value)}
                rows={4}
                placeholder="Brief biography..."
              />
            </label>
            <fieldset className="AdminPortal-fieldset">
              <legend className="AdminPortal-fieldLabel">Instruments / Roles</legend>
              <div className="AdminPortal-checkboxGroup">
                {INSTRUMENTS.map((inst) => (
                  <label key={inst} className="AdminPortal-checkbox">
                    <input
                      type="checkbox"
                      checked={personInstruments.includes(inst)}
                      onChange={() => toggleInstrument(inst)}
                    />
                    <span>{inst}</span>
                  </label>
                ))}
              </div>
            </fieldset>
            <button
              type="button"
              className="ChatButton AdminPortal-submitBtn"
              onClick={handleIngestionSubmit}
              disabled={ingestionLoading}
            >
              {ingestionLoading ? 'Adding…' : 'Add person'}
            </button>
          </div>
        </section>
      )}

      {ingestionType === 'song' && (
        <section className="AdminPortal-section">
          <h2 className="AdminPortal-sectionTitle">Add a song</h2>
          <p className="AdminPortal-sectionLead">
            Add a new song or composition to the archive.
          </p>
          <div className="AdminPortal-form">
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Title *</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={songTitle}
                onChange={(e) => setSongTitle(e.target.value)}
                placeholder="e.g. So What"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Composer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={songComposer}
                onChange={(e) => setSongComposer(e.target.value)}
                placeholder="e.g. Miles Davis"
              />
            </label>
            <button
              type="button"
              className="ChatButton AdminPortal-submitBtn"
              onClick={handleIngestionSubmit}
              disabled={ingestionLoading}
            >
              {ingestionLoading ? 'Adding…' : 'Add song'}
            </button>
          </div>
        </section>
      )}

      {ingestionType === 'album' && (
        <section className="AdminPortal-section">
          <h2 className="AdminPortal-sectionTitle">Add an album</h2>
          <p className="AdminPortal-sectionLead">
            Add an album or recording to the archive.
          </p>
          <div className="AdminPortal-form">
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Basic info</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Title *</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumTitle}
                onChange={(e) => setAlbumTitle(e.target.value)}
                placeholder="e.g. Kind of Blue"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Title artist</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumTitleArtist}
                onChange={(e) => setAlbumTitleArtist(e.target.value)}
                placeholder="e.g. Miles Davis"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Catalogue number</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumCatalogueNum}
                onChange={(e) => setAlbumCatalogueNum(e.target.value)}
                placeholder="e.g. MCGJ-1042"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">UPC</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumUpc}
                onChange={(e) => setAlbumUpc(e.target.value)}
                placeholder="e.g. 612262104223"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Release date</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumReleaseDate}
                onChange={(e) => setAlbumReleaseDate(e.target.value)}
                placeholder="e.g. 1959-08-17"
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Production credits</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Executive producer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumExecutiveProducer}
                onChange={(e) => setAlbumExecutiveProducer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Producer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumProducer}
                onChange={(e) => setAlbumProducer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Associate producer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumAssociateProducer}
                onChange={(e) => setAlbumAssociateProducer(e.target.value)}
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Engineering</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Recording engineer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumRecordingEngineer}
                onChange={(e) => setAlbumRecordingEngineer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Editing engineer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumEditingEngineer}
                onChange={(e) => setAlbumEditingEngineer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Mixing engineer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumMixingEngineer}
                onChange={(e) => setAlbumMixingEngineer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Mastering engineer</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumMasteringEngineer}
                onChange={(e) => setAlbumMasteringEngineer(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Assistants</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumAssistants}
                onChange={(e) => setAlbumAssistants(e.target.value)}
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Recording</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Recording dates</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumRecordingDates}
                onChange={(e) => setAlbumRecordingDates(e.target.value)}
                placeholder="e.g. March 2 & April 22, 1959"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Recording location</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumRecordingLocation}
                onChange={(e) => setAlbumRecordingLocation(e.target.value)}
                placeholder="e.g. Columbia 30th Street Studio, NYC"
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Design & art</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Cover art</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumCoverArt}
                onChange={(e) => setAlbumCoverArt(e.target.value)}
                placeholder="Link to the cover art image"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Cover art design</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumCoverArtDesign}
                onChange={(e) => setAlbumCoverArtDesign(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Package design</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumPackageDesign}
                onChange={(e) => setAlbumPackageDesign(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Photography</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumPhotography}
                onChange={(e) => setAlbumPhotography(e.target.value)}
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Liner notes</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Liner notes author</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumLinerNotesAuthor}
                onChange={(e) => setAlbumLinerNotesAuthor(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Liner notes text</span>
              <textarea
                className="AdminPortal-textarea"
                value={albumLinerNotesText}
                onChange={(e) => setAlbumLinerNotesText(e.target.value)}
                rows={8}
                placeholder="Paste the full liner notes text..."
              />
            </label>

            </div>
            <div className="AdminPortal-formSection">
            <h3 className="AdminPortal-fieldLabel">Other</h3>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Sponsor credit</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumSponsorCredit}
                onChange={(e) => setAlbumSponsorCredit(e.target.value)}
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Awards</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={albumAwards}
                onChange={(e) => setAlbumAwards(e.target.value)}
                placeholder="e.g. Grammy Nominee — Best Jazz Album, 2022"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Link to product</span>
              <input
                type="url"
                className="AdminPortal-input"
                value={albumLinkToProduct}
                onChange={(e) => setAlbumLinkToProduct(e.target.value)}
                placeholder="https://..."
              />
            </label>

            </div>
            <button
              type="button"
              className="ChatButton AdminPortal-submitBtn"
              onClick={handleIngestionSubmit}
              disabled={ingestionLoading}
            >
              {ingestionLoading ? 'Adding…' : 'Add album'}
            </button>
          </div>
        </section>
      )}

      {ingestionType === 'album_track' && (
        <section className="AdminPortal-section">
          <h2 className="AdminPortal-sectionTitle">Add an album track</h2>
          <p className="AdminPortal-sectionLead">
            Link a song to an album as a track. Both the album and song must already exist in the archive.
          </p>
          <div className="AdminPortal-form">
            <div className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Album *</span>
              <FkCombobox
                type="album"
                value={trackAlbumPick}
                onChange={setTrackAlbumPick}
                allowCreate={false}
                placeholder="Search album title or catalogue..."
                apiUrl={API_URL}
                authHeaders={authHeaders}
                disabled={ingestionLoading}
              />
            </div>
            <div className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Song *</span>
              <FkCombobox
                type="song"
                value={trackSongPick}
                onChange={(v) => {
                  setTrackSongPick(v);
                  if (!v || v.id) setTrackNewSongComposer('');
                }}
                allowCreate
                placeholder="Search song title..."
                apiUrl={API_URL}
                authHeaders={authHeaders}
                disabled={ingestionLoading}
              />
            </div>
            {trackSongPick && trackSongPick.createWith && (
              <label className="AdminPortal-field">
                <span className="AdminPortal-fieldLabel">Composer (for new song)</span>
                <input
                  type="text"
                  className="AdminPortal-input"
                  value={trackNewSongComposer}
                  onChange={(e) => setTrackNewSongComposer(e.target.value)}
                  placeholder="e.g. Miles Davis"
                />
              </label>
            )}
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Track number</span>
              <input
                type="number"
                className="AdminPortal-input"
                value={trackNumber}
                onChange={(e) => setTrackNumber(e.target.value)}
                placeholder="e.g. 3"
                min="1"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">ISRC</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={trackIsrc}
                onChange={(e) => setTrackIsrc(e.target.value)}
                placeholder="e.g. USMCG1234567"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Duration</span>
              <input
                type="text"
                className="AdminPortal-input"
                value={trackDuration}
                onChange={(e) => setTrackDuration(e.target.value)}
                placeholder="e.g. 5:42"
              />
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Vocal / Instrumental</span>
              <select
                className="AdminPortal-input"
                value={trackVocalInstrumental}
                onChange={(e) => setTrackVocalInstrumental(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="vocal">Vocal</option>
                <option value="instrumental">Instrumental</option>
              </select>
            </label>
            <label className="AdminPortal-field">
              <span className="AdminPortal-fieldLabel">Musicians</span>
              <textarea
                className="AdminPortal-textarea"
                value={trackMusicians}
                onChange={(e) => setTrackMusicians(e.target.value)}
                rows={4}
                placeholder="Names and instruments, e.g. Miles Davis (trumpet), Bill Evans (piano)..."
              />
            </label>
            <button
              type="button"
              className="ChatButton AdminPortal-submitBtn"
              onClick={handleIngestionSubmit}
              disabled={ingestionLoading}
            >
              {ingestionLoading ? 'Adding…' : 'Add album track'}
            </button>
          </div>
        </section>
      )}

      {ingestionType === 'event' && (
        <section className="AdminPortal-section">
          <h2 className="AdminPortal-sectionTitle">Add a concert / event</h2>
          <div className="AdminPortal-wizardSteps">
            {['Event details', 'Performers', 'Setlist'].map((label, i) => (
              <div
                key={label}
                className={`AdminPortal-wizardStep ${eventStep === i + 1 ? 'AdminPortal-wizardStep--active' : ''} ${eventStep > i + 1 ? 'AdminPortal-wizardStep--done' : ''}`}
              >
                <span className="AdminPortal-wizardStepNum">{i + 1}</span>
                <span>{label}</span>
              </div>
            ))}
          </div>

          {eventStep === 1 && (
            <div className="AdminPortal-form">
              <label className="AdminPortal-field">
                <span className="AdminPortal-fieldLabel">Title *</span>
                <input
                  type="text"
                  className="AdminPortal-input"
                  value={eventTitle}
                  onChange={(e) => setEventTitle(e.target.value)}
                  placeholder="e.g. Friday Night Jazz"
                />
              </label>
              <label className="AdminPortal-field">
                <span className="AdminPortal-fieldLabel">Date *</span>
                <input
                  type="date"
                  className="AdminPortal-input"
                  value={eventDate}
                  onChange={(e) => setEventDate(e.target.value)}
                />
              </label>
              <div className="AdminPortal-field">
                <span className="AdminPortal-fieldLabel">Location</span>
                <FkCombobox
                  type="location"
                  value={eventLocationPick}
                  onChange={setEventLocationPick}
                  allowCreate
                  placeholder="Search or create a location..."
                  apiUrl={API_URL}
                  authHeaders={authHeaders}
                />
              </div>
              <label className="AdminPortal-field">
                <span className="AdminPortal-fieldLabel">Description</span>
                <textarea
                  className="AdminPortal-textarea"
                  value={eventDescription}
                  onChange={(e) => setEventDescription(e.target.value)}
                  rows={3}
                  placeholder="Event description..."
                />
              </label>
              <div className="AdminPortal-wizardNav">
                <span />
                <button
                  type="button"
                  className="ChatButton"
                  onClick={() => {
                    if (!eventTitle.trim() || !eventDate) {
                      setIngestionError('Event title and date are required.');
                      return;
                    }
                    setIngestionError(null);
                    setEventStep(2);
                  }}
                >
                  Next &rarr;
                </button>
              </div>
            </div>
          )}

          {eventStep === 2 && (
            <div className="AdminPortal-form">
              <p className="AdminPortal-sectionLead">
                Add performers and their roles for this event. Pick an existing person/role or create a new one.
              </p>
              {eventPerformers.length > 0 && (
                <div className="AdminPortal-tableWrap">
                  <table className="AdminPortal-table">
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Role</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventPerformers.map((p, i) => (
                        <tr key={i}>
                          <td>
                            {p.personPick?.createWith
                              ? `New: "${p.personPick.createWith}"`
                              : p.personPick?.label}
                          </td>
                          <td>
                            {p.rolePick?.createWith
                              ? `New: "${p.rolePick.createWith}"`
                              : p.rolePick?.label || '—'}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="ChatButton AdminPortal-delete"
                              onClick={() => removePerformer(i)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="AdminPortal-addRow">
                <div style={{ flex: 1 }}>
                  <FkCombobox
                    type="person"
                    value={newPerformerPick}
                    onChange={setNewPerformerPick}
                    allowCreate
                    placeholder="Search or create a performer..."
                    apiUrl={API_URL}
                    authHeaders={authHeaders}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <FkCombobox
                    type="role"
                    value={newPerformerRolePick}
                    onChange={setNewPerformerRolePick}
                    allowCreate
                    placeholder="Role (e.g. trumpet)"
                    apiUrl={API_URL}
                    authHeaders={authHeaders}
                  />
                </div>
                <button type="button" className="ChatButton" onClick={addPerformer}>
                  Add
                </button>
              </div>
              <div className="AdminPortal-wizardNav">
                <button type="button" className="ChatButton" onClick={() => setEventStep(1)}>
                  &larr; Back
                </button>
                <button type="button" className="ChatButton" onClick={() => setEventStep(3)}>
                  Next &rarr;
                </button>
              </div>
            </div>
          )}

          {eventStep === 3 && (
            <div className="AdminPortal-form">
              <div className="AdminPortal-wizardSummary">
                <strong>{eventTitle}</strong> &mdash; {eventDate}
                {eventLocationPick
                  ? ` at ${eventLocationPick.createWith
                      ? `"${eventLocationPick.createWith}"`
                      : eventLocationPick.label}`
                  : ''}
                {eventPerformers.length > 0 && (
                  <span> &mdash; {eventPerformers.length} performer{eventPerformers.length !== 1 ? 's' : ''}</span>
                )}
              </div>
              <p className="AdminPortal-sectionLead">
                Add the setlist for this event. Songs are ordered by track number.
              </p>
              {eventSetlist.length > 0 && (
                <div className="AdminPortal-tableWrap">
                  <table className="AdminPortal-table">
                    <thead>
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col">Song title</th>
                        <th scope="col">Composer</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {eventSetlist.map((s, i) => (
                        <tr key={i}>
                          <td>{s.trackNumber}</td>
                          <td>
                            {s.songPick?.createWith
                              ? `New: "${s.songPick.createWith}"`
                              : s.songPick?.label}
                          </td>
                          <td>{s.composer || '—'}</td>
                          <td>
                            <button
                              type="button"
                              className="ChatButton AdminPortal-delete"
                              onClick={() => removeSetlistSong(i)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <div className="AdminPortal-addRow">
                <div style={{ flex: 2 }}>
                  <FkCombobox
                    type="song"
                    value={newSongPick}
                    onChange={(v) => {
                      setNewSongPick(v);
                      if (!v?.createWith) setNewSongComposer('');
                    }}
                    allowCreate
                    placeholder="Search or create a song..."
                    apiUrl={API_URL}
                    authHeaders={authHeaders}
                  />
                </div>
                <input
                  type="number"
                  className="AdminPortal-input AdminPortal-trackInput"
                  value={newSongTrack}
                  onChange={(e) => setNewSongTrack(e.target.value)}
                  placeholder="#"
                  min={1}
                />
                <button type="button" className="ChatButton" onClick={addSetlistSong}>
                  Add
                </button>
              </div>
              {newSongPick?.createWith && (
                <div className="AdminPortal-addRow" style={{ marginTop: '0.5rem' }}>
                  <input
                    type="text"
                    className="AdminPortal-input"
                    value={newSongComposer}
                    onChange={(e) => setNewSongComposer(e.target.value)}
                    placeholder={`Composer for "${newSongPick.createWith}" (optional)`}
                  />
                </div>
              )}
              <div className="AdminPortal-wizardNav">
                <button type="button" className="ChatButton" onClick={() => setEventStep(2)}>
                  &larr; Back
                </button>
                <button
                  type="button"
                  className="ChatButton AdminPortal-submitBtn"
                  onClick={handleIngestionSubmit}
                  disabled={ingestionLoading}
                >
                  {ingestionLoading ? 'Submitting…' : 'Submit event'}
                </button>
              </div>
            </div>
          )}
        </section>
      )}
    </>
  );
};
